import { Injectable } from '@angular/core';
import { DataService } from '../../../../../shared/services/data.service';
import { OemExcessPaginationModel } from '../../../../../shared/components/ag-grid/ag-grid.model';
import { Result } from '../../../../../shared/model/response.model';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OemExcessService {
  constructor(public service:DataService) { }

  getAllOemExcessList(data: OemExcessPaginationModel):  Observable<Result>{
    let url = "app/parts_Inventory/getAllOemExcess";
    return this.service.getWithParams(url,data).pipe<Result>(
      tap((response:any)=> {
        return response;
      })
    )
  }

  getUpdateOem(data: any): Observable<Result> {
    let url = "app/parts_Inventory/updateOemExcess";
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response
      })
    )
  }

  deleteOemParts(data:any): Observable<Result> {
    let url = 'app/parts_Inventory/deleteOEMExcess';
    return this.service.post(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
  }

  addOemExcess(data: any): Observable<Result> {
      let url = 'app/parts_Inventory/addOemExcess';
      return this.service.post(url, data).pipe<Result>(
        tap((response: any) => {
          return response;
        })
      );
    }
    getOemList(data:any){
      let url = "app/parts_Inventory/getAllOEMExcessListbyCompanyId";
    return this.service.getWithParams(url, data).pipe<Result>(
      tap((response: any) => {
        return response;
      })
    );
    }
    
  getOemExcessById(id:string): Observable<Result> {
    let url = `app/parts_Inventory/getOemExcessById?Id=${id}`;
    return this.service.get(url,true).pipe<Result>(tap((response: any) => {
     return response;
      })
    );
  }
}
